//Performs a smooth page scroll to an anchor on the same page.
//Gets overriden by barba if it's not on the same page...
//Generell musste ich barba beibringen korrekt mit anchor links umzugehen... Bei neueren Versionen funktioniert das out of the box
$('.anchor-link').click(function() {
    var offset = 0; // <-- change the value here
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
            $('html, body').animate({
                scrollTop: target.offset().top + offset
            }, 1000);
            return false;
        }
    }
});